import { render, staticRenderFns } from "./projectDialog.vue?vue&type=template&id=900a0320&scoped=true&"
import script from "./projectDialog.vue?vue&type=script&lang=js&"
export * from "./projectDialog.vue?vue&type=script&lang=js&"
import style0 from "./projectDialog.vue?vue&type=style&index=0&id=900a0320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900a0320",
  null
  
)

export default component.exports